// extracted by mini-css-extract-plugin
export default {"nameInfo":"NameInfoContent_nameInfo__-DuFx","nameInfoParagraph":"NameInfoContent_nameInfoParagraph__tB1+p","nameInfoSVG":"NameInfoContent_nameInfoSVG__z4lv4"};